<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'partitions.sunburst.title.shortLabel' | translate}} (<span class="year">{{ year }}</span>)
                <app-tooltip data-html2canvas-ignore [text]="'partitions.sunburst.title.summary' | translate">
                </app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <app-partitions-sunburst
            [mainPartition]="mainPartition"
            [selected]="selected"
            [selectedCodes]="selectedCodes"
            [year]="year"
            [chartSize]="chartSize"
            [isGrey]="isGrey"></app-partitions-sunburst>
    </mat-card-content>
</mat-card>
